// removed by extract-text-webpack-plugin
module.exports = {"empty-container":"hCHezmOqvoGzIuIebAgiB","content":"_1fx7kgMNJCXx1TSqyHGSUG","container":"_26QtLjWocyVXLNNp0U1HZW","image-gallery":"_2VrSegn9iSZh2jVhABccYt"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailTypeInstance.less
 ** module id = 854
 ** module chunks = 0
 **/